export default __webpack_public_path__ + "static/media/shuttle_map_en.6b13d8ff.svg";